import { GridIconSetting, UserSettings } from "./../pb-screen/models/application.user.interface";
import { SharedActions } from "./../shared/shared.actions";
import { Component, ElementRef, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { environment } from "../../environments/environment";
import { select } from "@angular-redux/store";
import { ApplicationUser, DocumentToBePrinted } from "../pb-screen/models/application.user.interface";
import { combineLatest, Observable, Subject } from "rxjs";
import { ApplicationUserActions } from "../pb-screen/application.user.actions";
import { settingAction } from "./setting.action";
import { TranslateService } from "@ngx-translate/core";
import { HttpClientService } from "../shared/services/httpclient";
import { UserSettingsService } from "../pb-screen/services/usersettings.service";
import { GeneralSetting, PlanningSetting, TmsActionCodeColorSetting, WeekPlanningSetting } from "./setting-modal.interface";
import { IdNameAsStringObject } from "../pb-screen/models/quick-view/id-name-as-string-object.interface";
import { RE_USED } from "../pb-screen/models/status-type.interface";
import { UserFeedbackService } from "../services/user-feedback.service";
import { TmsActionService } from "../shared/services/tms-action.service";
import { filter, take, takeUntil } from "rxjs/operators";
import { ActionCodeColor } from "../shared/models/action-code-color";
import { TmsAction } from "../shared/models/tms-action.interface";

import { ButtonVisibility } from "../shared/models/buttons-visibility";
import * as _ from "lodash";
import { PlanDateSuggestionOption } from "../shared/models/defaultPlanDateOption";

@Component({
  moduleId: module.id,
  selector: "setting-modal",
  templateUrl: "setting-modal.component.html"
})
export class settingComponent implements OnInit, OnDestroy {
  environment = environment

  @ViewChild("modal") public modal: ElementRef;
  @Output("companyName") companyName = environment.envName;
  applicationUser: ApplicationUser;
  @select("planningGroups") public planningGroups$: Observable<IdNameAsStringObject[]>;
  @select("applicationUser") applicationUser$: Observable<ApplicationUser>;
  @select("planningZone") public planningZone$: Observable<any[]>;
  @select("globalSettings") public globalSettings$: Observable<UserSettings[]>;
  public enableAutocomplete: boolean = false;
  private readonly _destroying$ = new Subject<void>();

  enableBargeAndCaptainLabels = false;
  enableBargeAndCaptainLabelsSetting: UserSettings;

  fileToUpload: File = null;
  currentGridIcon: GridIconSetting[];
  toIcons: GridIconSetting[];
  activeTab = 1;
  pixelsPerPlanningBlock: number;
  weekPlanningSetting: WeekPlanningSetting = new WeekPlanningSetting();
  planningSetting: PlanningSetting = new PlanningSetting();
  generalSetting: GeneralSetting = new GeneralSetting();
  public planningGroups: IdNameAsStringObject[] = [];
  public planningZones: any[];

  PrintedDocumentDefinitions: any = [
    { docName: "Transport Order Document", availableOnlyFor: "TO-Screen,TO-Screen-Details,PB-Screen" },
    { docName: "Cmr", availableOnlyFor: "PB-Screen,PB-Screen-Details,Depot-In,Depot-Out,TO-Screen" },
    { docName: "Container Planning List (Excel)", availableOnlyFor: "Depot-In,Depot-Out" },
    { docName: "Container Planning List (PDF)", availableOnlyFor: "Depot-In,Depot-Out" },
    { docName: "Print Ticket", availableOnlyFor: "Depot-In,Depot-Out,PB-Screen" },
    { docName: "Container Planning List Warehouse", availableOnlyFor: "Depot-In,Depot-Out" },
    //{ docName: "Week Planning Report", availableOnlyFor: "Depot-In,Depot-Out,PB-Screen" }, ,
    { docName: "Checklist Container Stuffing - Staal", availableOnlyFor: "Depot-In,Depot-Out,PB-Screen" },
    { docName: "Shuttle List", availableOnlyFor: "Depot-In,Depot-Out,PB-Screen" },
    { docName: "Stacker List", availableOnlyFor: "Depot-In,Depot-Out,PB-Screen" },

  ];
  PrintedDocumentList: any = [];
  selectedScreen: string = "";
  checkedStrings;
  screenList: any = [
    "Depot-In",
    "Depot-Out",
    "PB-Screen",
    "PB-Screen-Details",
    "TO-Screen",
    "TO-Screen-Details"
  ];

  backgroundImageUrl = environment.hubEndpointAddress + "/App/assets/images/backgrounds/icons/";
  backgrounds = [
    { text: "Container", landingPage: "1" },
    { text: "Short sea shipping", landingPage: "shortsea" },
    { text: "Barge Shipping", landingPage: "inlandshipping" },
    { text: "Tank", landingPage: "tank" },
    { text: "Groupage & distribution", landingPage: "groupage_distribution" },
    { text: "Intermodal", landingPage: "intermodal" },
    { text: "International", landingPage: "international" },
    { text: "Custom", landingPage: "custom" }
  ];
  defaultPBGridIcon: GridIconSetting[] = [
    { "id": 1, "isVisible": true, "name": "Scanning" },
    { "id": 2, "isVisible": true, "name": "Customs" },
    { "id": 3, "isVisible": true, "name": "Weighing" },
    { "id": 4, "isVisible": true, "name": "ADR" },
    { "id": 5, "isVisible": true, "name": "T1" },
    { "id": 6, "isVisible": true, "name": "Temperature" },
    { "id": 7, "isVisible": true, "name": "High Value" },
    { "id": 8, "isVisible": true, "name": "Conflicts" },
    { "id": 9, "isVisible": true, "name": "Notifications" },
    { "id": 10, "isVisible": true, "name": "Remarks" },
    environment.tarTasEnabled ? { "id": 11, "isVisible": true, "name": "Pre-Announcement Status" } : null,
    environment.tarTasEnabled ? { "id": 12, "isVisible": true, "name": "Truck Appointment Status" } : null,
    environment.containerReleaseEnabled ? { "id": 13, "isVisible": true, "name": "Container Release Status" } : null,
    { "id": 14, "isVisible": false, "name": "Documents" },
    { "id": 15, "isVisible": false, "name": "SideLoader" },
    { "id": 16, "isVisible": false, "name": "Genset" }

  ];

  public depotInGridIcons: GridIconSetting[];
  defaultDepotInGridIcons: GridIconSetting[] = [
    { "id": 1, "isVisible": true, "name": "Scanning" },
    { "id": 2, "isVisible": true, "name": "Customs" },
    { "id": 3, "isVisible": true, "name": "Weighing" },
    { "id": 4, "isVisible": true, "name": "ADR" },
    { "id": 5, "isVisible": true, "name": "T1" },
    { "id": 6, "isVisible": true, "name": "Container Pool Status" },
    { "id": 7, "isVisible": true, "name": "hasTarTasCode" },
    environment.tarTasEnabled ? { "id": 8, "isVisible": true, "name": "Pre-Announcement Status" } : null,
    environment.tarTasEnabled ? { "id": 9, "isVisible": true, "name": "Truck Appointment Status" } : null,
    { "id": 10, "isVisible": true, "name": "Temperature" },
    { "id": 11, "isVisible": true, "name": "High Value" },
    environment.containerReleaseEnabled ? { "id": 12, "isVisible": true, "name": "Container Release Status" } : null,
    { "id": 13, "isVisible": false, "name": "SideLoader" },
    { "id": 14, "isVisible": false, "name": "Genset" }

  ];

  public depotOutGridIcons: GridIconSetting[];
  defaultDepotOutGridIcons: GridIconSetting[] = [
    { "id": 1, "isVisible": true, "name": "Scanning" },
    { "id": 2, "isVisible": true, "name": "Customs" },
    { "id": 3, "isVisible": true, "name": "Weighing" },
    { "id": 4, "isVisible": true, "name": "ADR" },
    { "id": 5, "isVisible": true, "name": "T1" },
    { "id": 6, "isVisible": true, "name": "Container Pool Status" },
    { "id": 7, "isVisible": true, "name": "hasTarTasCode" },
    environment.tarTasEnabled ? { "id": 8, "isVisible": true, "name": "Pre-Announcement Status" } : null,
    environment.tarTasEnabled ? { "id": 9, "isVisible": true, "name": "Truck Appointment Status" } : null,
    { "id": 10, "isVisible": true, "name": "Temperature" },
    { "id": 11, "isVisible": true, "name": "High Value" },
    environment.containerReleaseEnabled ? { "id": 12, "isVisible": true, "name": "Container Release Status" } : null,
    { "id": 13, "isVisible": false, "name": "SideLoader" } ,
    { "id": 14, "isVisible": false, "name": "Genset" }
  ];
  defaultToGridIcon: GridIconSetting[] = [
    { "id": 1, "isVisible": true, "name": "Margin (Cost, Revenue)" },
    { "id": 2, "isVisible": true, "name": "Temperature" },
    { "id": 3, "isVisible": true, "name": "High Value" },
    { "id": 4, "isVisible": true, "name": "ADR" },
    { "id": 5, "isVisible": true, "name": "Conflicts" },
    { "id": 6, "isVisible": true, "name": "Remarks" },
    { "id": 7, "isVisible": true, "name": "Notifications" },
    { "id": 8, "isVisible": true, "name": "TO Send Status" },
    { "id": 9, "isVisible": true, "name": "Error on Bc" }
  ];

  selectedBackground;
  landingPageSetting: UserSettings;
  pixelsPerPBSetting: UserSettings;
  weekPlanningUserSetting: UserSettings;
  tmsActionCodeColorSetting: UserSettings;
  tmsActionCodeColorSettingValue: TmsActionCodeColorSetting;
  generalUserSetting: UserSettings;
  planningUserSetting: UserSettings;
  timeline = {
    value: false
  };


  colllpasedPbs = {
    value: false
  };
  timeLineSetting: UserSettings;

  changeSequence = {
    value: false
  };
  sequenceSettings: UserSettings;

  checkDateCompatibility: boolean = false;
  checkDateCompatibilitySetting: UserSettings;

  usePopupScreenForEditingOrderlines = false;
  usePopupScreenForEditingOrderlinesSetting: UserSettings;

  collpasedSetting: UserSettings;
  public selectedPlanningGroups: any = [];

  enableContainerSwap: boolean = false;
  enableContainerSwapSetting: UserSettings;

  buttonsVisibility: ButtonVisibility[] = [];
  buttonsVisibilitySetting: UserSettings;
  suggestPlanDateOptionsList = [];
  suggestPlanDateOptionSetting: UserSettings = null;
  suggestPlanDateOption: string = PlanDateSuggestionOption.Today;
  serverSideFilteringSetting: UserSettings = null;
  serverSideFiltering: boolean = false;
  enableOptimisticUiSetting: UserSettings = null;
  enableOptimisticUi: boolean = false;
  enableOptimisticUiBoardSetting: UserSettings = null;
  enableOptimisticUiPlanningBoard: boolean = false;

  constructor(
    private translate: TranslateService,
    private settingActions: settingAction,
    private actions: SharedActions,
    private readonly userFeedbackService: UserFeedbackService,
    private userActions: ApplicationUserActions,
    private readonly http: HttpClientService,
    private readonly userSettingsService: UserSettingsService,
    private tmsActionService: TmsActionService,
  ) {
  }


  ngOnInit() {
    this.applicationUser$.pipe(takeUntil(this._destroying$)).subscribe((applicationUser: ApplicationUser) => {
      if (applicationUser) {
        this.enableAutocomplete = applicationUser.generalSetting.enableAutocomplete;
        this.applicationUser = applicationUser;
        this.weekPlanningSetting = this.applicationUser.weekPlanningSetting ? this.applicationUser.weekPlanningSetting : this.weekPlanningSetting;
        this.planningSetting = this.applicationUser.planningSetting ? this.applicationUser.planningSetting : this.planningSetting;
        this.currentGridIcon = this.getGridIcon(this.defaultPBGridIcon, this.applicationUser.defaultGridIcon);
        this.toIcons = this.getGridIcon(this.defaultToGridIcon, this.applicationUser.toIcons);
        this.depotInGridIcons = this.getGridIcon(this.defaultDepotInGridIcons, this.applicationUser.depotInGridIcons);
        this.depotOutGridIcons = this.getGridIcon(this.defaultDepotOutGridIcons, this.applicationUser.depotOutGridIcons);
        this.pixelsPerPlanningBlock = this.applicationUser.pixelsPerPlanningBlock;
        this.weekPlanningSetting = this.applicationUser.weekPlanningSetting ? this.applicationUser.weekPlanningSetting : this.weekPlanningSetting;
        this.planningSetting = this.applicationUser.planningSetting ? this.applicationUser.planningSetting : this.planningSetting;
        this.generalSetting = this.applicationUser.generalSetting ? this.applicationUser.generalSetting : this.generalSetting;
        this.generalSetting.autoCloseSignalRConnectionWarning =
          this.generalSetting.autoCloseSignalRConnectionWarning === true;
        if (this.generalSetting.enableReuseSummary === undefined || this.generalSetting.enableReuseSummary === null) {
          this.generalSetting.enableReuseSummary = false;
        }
        this.enableContainerSwap = this.applicationUser.enableContainerSwap ? this.applicationUser.enableContainerSwap : this.enableContainerSwap;
        this.checkDateCompatibility = this.applicationUser.checkDateCompatibility;
        this.enableOptimisticUi = this.applicationUser.enableOptimisticUi;
        this.enableOptimisticUiPlanningBoard = this.applicationUser.enableOptimisticUiPlanningBoard;
        this.usePopupScreenForEditingOrderlines = this.applicationUser.usePopupScreenForEditingOrderlines;
        this.selectedPlanningGroups = this.planningGroups.filter((x) => {
          if (!this.generalSetting.defaultPlanningGroupes) {
            return false;
          }
          return this.generalSetting.defaultPlanningGroupes.indexOf(x.id) !== -1;
        });

        if (!this.generalSetting.orderlineReuseStatus) {
          this.generalSetting.orderlineReuseStatus = RE_USED;
        }

        if (!this.generalSetting.moveToPoolAllowedAddresses && environment.containerPoolEnabled) {
          this.generalSetting.moveToPoolAllowedAddresses = "";
        }

        if (!this.generalSetting.stackerSites && environment.stackerIcon) {
          this.generalSetting.stackerSites = "";
        }

        if (this.applicationUser.buttonsVisibility) {
          this.buttonsVisibility = _.cloneDeep(this.applicationUser.buttonsVisibility);
        }

        this.enableBargeAndCaptainLabels = this.applicationUser.enableBargeAndCaptainLabels;
        this.suggestPlanDateOption = this.applicationUser.suggestPlanDateOption;
        this.serverSideFiltering = this.applicationUser.serverSideFiltering;
      }

    });

    this.planningGroups$.subscribe(
      (planningGroups: IdNameAsStringObject[]) => {
        this.planningGroups = planningGroups;
        this.selectedPlanningGroups = this.planningGroups.filter((x) => {
          if (!this.generalSetting.defaultPlanningGroupes) {
            return false;
          }
          return this.generalSetting.defaultPlanningGroupes.indexOf(x.id) !== -1;
        });
      }
    );
    this.planningZone$.subscribe((planningZones: any) => {
      if (planningZones) {
        this.planningZones = planningZones;
        this.planningZones = this.planningZones.map(x => x.id);
      }
    });
    this.globalSettings$.subscribe(result => {
      if (result.length) {
        this.getLandingPageSetting(result);
        this.getPixelsPerPlanningBlock(result);
        this.getContainerSwapSetting(result);
        this.getEnableBargeAndCaptainLabelsSetting(result);
        this.getWeekPlanningSettings(result);
        this.getGeneralSettings(result);
        this.getPlanningSetting(result);
        this.getTimelineSetting(result);
        this.getCollapsedPbsSetting(result);
        this.getCheckDateCompatibilitySetting(result);
        this.getButtonsVisibilitySetting(result);
        this.getUsePopupScreenForEditingOrderlinesSetting(result);
        this.getSuggestPlanDateOptionSetting(result);
        this.getServerSideFilteringSetting(result);
        this.getEnableOptimisticUiSetting(result);
        this.getEnableOptimisticUiBoardSetting(result);

      }
    });

    combineLatest([
      this.globalSettings$.pipe(filter(val => val !== null)),
      this.applicationUser$.pipe(filter(val => val !== null))
    ]).subscribe(([globalSettings, applicationUser]) => {
      this.tmsActionCodeColorSettingValue = applicationUser.tmsActionCodeColorSetting;
      this.getTmsActionCodeColorSettings(globalSettings);
    });

    if (this.suggestPlanDateOptionsList.length == 0) {
      this.setSuggestPlanDateOptionsList();
    }

  }

  setSuggestPlanDateOptionsList() {

    this.suggestPlanDateOptionsList = [];
    for (const item of Object.keys(PlanDateSuggestionOption)) {

      this.translate.get("SETTING_MODAL.SUGGEST_PLAN_DATE_OPTIONS_LIST." + item).subscribe((res: string) => {
        this.suggestPlanDateOptionsList.push({ value: item, label: res });
      });

    }

  }


  getLandingPageSetting(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == "landingPage");
    this.selectedBackground = this.backgrounds[0];
    if (setting) {
      this.selectedBackground = this.backgrounds.find(el => el.landingPage === setting.value);
      this.landingPageSetting = setting;
    }
  }

  getCollapsedPbsSetting(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == "collapsedPbs");
    if (setting) {
      this.collpasedSetting = setting;
      this.colllpasedPbs.value = setting.value == "true" ? true : false;
    }
  }

  getTimelineSetting(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == "timeline");
    if (setting) {
      this.timeLineSetting = setting;
      this.timeline.value = setting.value == "true" ? true : false;
      localStorage.setItem("timeLine", setting.value);
    }
  }

  getPlanningSetting(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == "planning");
    if (setting) {
      this.planningUserSetting = setting;
    }
  }

  getGeneralSettings(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == "generalSettings");
    if (setting) {
      this.generalUserSetting = setting;
    }
  }

  getWeekPlanningSettings(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == "weekPlanning");
    if (setting) {
      this.weekPlanningUserSetting = setting;
    }
  }

  getTmsActionCodeColorSettings(settings: UserSettings[]) {
    const setting = settings.find(el => el.setting.name === "tmsActionCodeColors");
    this.tmsActionCodeColorSetting = setting;

    this.setAndUpdateActionColors();
  }

  getPixelsPerPlanningBlock(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == "pixelsPerPlanningBlock");
    if (setting) {
      this.pixelsPerPBSetting = setting;
    }
  }

  getContainerSwapSetting(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == "enableContainerSwap");
    if (setting) {
      this.enableContainerSwapSetting = setting;
    }
  }

  getEnableBargeAndCaptainLabelsSetting(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == "enableBargeAndCaptainLabels");
    if (setting) {
      this.enableBargeAndCaptainLabelsSetting = setting;
    }
  }

  getSuggestPlanDateOptionSetting(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == "suggestPlanDateOption");
    if (setting) {
      this.suggestPlanDateOptionSetting = setting;
    }
  }

  getServerSideFilteringSetting(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == "serverSideFiltering");
    if (setting) {
      this.serverSideFilteringSetting = setting;
    }
  }

  getEnableOptimisticUiSetting(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == "enableOptimisticUi");
    if (setting) {
      this.enableOptimisticUiSetting = setting;
    }
  }

  getEnableOptimisticUiBoardSetting(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == "enableOptimisticUiPlanningBoard");
    if (setting) {
      this.enableOptimisticUiBoardSetting = setting;
    }
  }

  getButtonsVisibilitySetting(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == 'buttonsVisibility');
    if (setting) {
      this.buttonsVisibilitySetting = setting;
    }
  }

  getUsePopupScreenForEditingOrderlinesSetting(settings: UserSettings[]) {
    const setting = settings.find(el => el.setting.name == "usePopupScreenForEditingOrderlines");

    if (setting) {
      this.usePopupScreenForEditingOrderlinesSetting = setting;
    }
  }

  getChangeSequenceSetting(settings: UserSettings[]) {
    var setting = settings.find(el => el.setting.name == "changeSequence");
    if (setting) {
      this.sequenceSettings = setting;
      this.changeSequence.value = setting.value == "true" ? true : false;
      localStorage.setItem("changeSequence", setting.value);
    }
  }

  public closeModal(): void {
    this.modal.nativeElement.click();
  }

  changeTabStatus(val) {
    this.activeTab = val;
  }

  radioChangeHandlar(event: any) {
    this.selectedScreen = event.target.value;
    this.fillDocumentsList();
  }
  fillDocumentsList() {
    this.PrintedDocumentList = this.PrintedDocumentDefinitions.filter(x => x.availableOnlyFor.includes(this.selectedScreen));
  }

  SelectDocToPrint(event) {
    if (event.target.checked === true) {
      const Document: DocumentToBePrinted = {
        name: event.target.value
      };
      switch (this.selectedScreen) {
        case "Depot-In":
          this.applicationUser.Screens.depotIn.push(Document);
          break;
        case "Depot-Out":
          this.applicationUser.Screens.depotOut.push(Document);
          break;
        case "PB-Screen":
          this.applicationUser.Screens.pbscreen.push(Document);
          break;
        case "PB-Screen-Details":
          this.applicationUser.Screens.pbdetails.push(Document);
          break;
        case "TO-Screen":
          this.applicationUser.Screens.toscreen.push(Document);
          break;
        case "TO-Screen-Details":
          this.applicationUser.Screens.todetails.push(Document);
          break;
        case "Planning-Board":
          this.applicationUser.Screens.planningBoard.push(Document);
          break;
      }
    } else {
      switch (this.selectedScreen) {
        case "Depot-In":
          const index1 = this.applicationUser.Screens.depotIn.indexOf(
            this.applicationUser.Screens.depotIn.filter(
              x => x.name === event.target.value
            )[0]
          );
          if (index1 !== -1) {
            this.applicationUser.Screens.depotIn.slice(0, index1);
            this.applicationUser.Screens.depotIn.splice(index1, 1);
          }
          break;
        case "Depot-Out":
          const index2 = this.applicationUser.Screens.depotOut.indexOf(
            this.applicationUser.Screens.depotOut.filter(
              x => x.name === event.target.value
            )[0]
          );
          if (index2 !== -1) {
            this.applicationUser.Screens.depotOut.slice(0, index2);
            this.applicationUser.Screens.depotOut.splice(index2, 1);
          }
          break;
        case "PB-Screen":
          const index3 = this.applicationUser.Screens.pbscreen.indexOf(
            this.applicationUser.Screens.pbscreen.filter(
              x => x.name === event.target.value
            )[0]
          );
          if (index3 !== -1) {
            this.applicationUser.Screens.pbscreen.slice(0, index3);
            this.applicationUser.Screens.pbscreen.splice(index3, 1);
          }
          break;
        case "PB-Screen-Details":
          const index4 = this.applicationUser.Screens.pbdetails.indexOf(
            this.applicationUser.Screens.pbdetails.filter(
              x => x.name === event.target.value
            )[0]
          );
          if (index4 !== -1) {
            this.applicationUser.Screens.pbdetails.slice(0, index4);
            this.applicationUser.Screens.pbdetails.splice(index4, 1);
          }
          break;
        case "TO-Screen":
          const index5 = this.applicationUser.Screens.toscreen.indexOf(
            this.applicationUser.Screens.toscreen.filter(
              x => x.name === event.target.value
            )[0]
          );
          if (index5 !== -1) {
            this.applicationUser.Screens.toscreen.slice(0, index5);
            this.applicationUser.Screens.toscreen.splice(index5, 1);
          }
          break;
        case "TO-Screen-Details":
          const index6 = this.applicationUser.Screens.todetails.indexOf(
            this.applicationUser.Screens.todetails.filter(
              x => x.name === event.target.value
            )[0]
          );
          if (index6 !== -1) {
            this.applicationUser.Screens.todetails.slice(0, index6);
            this.applicationUser.Screens.todetails.splice(index6, 1);
          }
          break;
        case "Planning-Board":
          const index7 = this.applicationUser.Screens.planningBoard.indexOf(
            this.applicationUser.Screens.planningBoard.filter(
              x => x.name === event.target.value
            )[0]
          );
          if (index7 !== -1) {
            this.applicationUser.Screens.planningBoard.slice(0, index7);
            this.applicationUser.Screens.planningBoard.splice(index7, 1);
            break;
          }
      }
    }
  }

  IsChecked(elementName: string): boolean {
    var disblay = false;
    if (this.selectedScreen === "Depot-In") {
      this.applicationUser.Screens.depotIn.map(x => {
        if (x.name === elementName) {
          disblay = true;
          return;
        }
      });
      return disblay;
    } else if (this.selectedScreen === "Depot-Out") {
      this.applicationUser.Screens.depotOut.map(x => {
        if (x.name === elementName) {
          disblay = true;
          return;
        }
      });
      return disblay;
    } else if (this.selectedScreen === "PB-Screen") {
      this.applicationUser.Screens.pbscreen.map(x => {
        if (x.name === elementName) {
          disblay = true;
          return;
        }
      });
      return disblay;
    } else if (this.selectedScreen === "PB-Screen-Details") {
      this.applicationUser.Screens.pbdetails.map(x => {
        if (x.name === elementName) {
          disblay = true;
          return;
        }
      });
      return disblay;
    } else if (this.selectedScreen === "TO-Screen") {
      this.applicationUser.Screens.toscreen.map(x => {
        if (x.name === elementName) {
          disblay = true;
          return;
        }
      });
      return disblay;
    } else if (this.selectedScreen === "TO-Screen-Details") {
      this.applicationUser.Screens.todetails.map(x => {
        if (x.name === elementName) {
          disblay = true;
          return;
        }
      });
      return disblay;
    } else if (this.selectedScreen === "Planning-Board") {
      this.applicationUser.Screens.planningBoard.map(x => {
        if (x.name === elementName) {
          disblay = true;
          return;
        }
      });
      return disblay;
    }
  }

  handleFileInput(files: FileList) {
    var file = files.item(0);
    if ((file.name.endsWith(".jpg") || file.name.endsWith(".jpeg")) && this.checkFileSize(file)) {
      this.fileToUpload = file;
    } else {
      this.fileToUpload = null;
      this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.WRONG_IMAGE_FORMAT");
    }
  }

  checkFileSize(file: File) {
    // less than 100 MB - limit on server
    return ((file.size / (1024 * 1024)) < 100);
  }

  updateCustomImage() {
    const reader = new FileReader();
    reader.readAsDataURL(this.fileToUpload);
    reader.onload = () => {
      this.updateCustomImageOnServer(<string>reader.result);
    };
    reader.onerror = error => this.userFeedbackService.showErrorMessageWithoutTranslating(error.type);
  }

  updateCustomImageOnServer(base64File: string) {
    base64File = base64File.substr(base64File.indexOf(",") + 1);
    this.http.post(environment.hubEndpointAddress + "/home/CustomLandingPage", base64File).subscribe(
      () => {
        var custom = this.backgrounds[this.backgrounds.length - 1];
        this.backgrounds.splice(this.backgrounds.length - 1);
        this.backgrounds.push(custom);

        this.userFeedbackService.showSuccessMessage("TOASTR_MESSAGES.SUCCESS.LANDINGPAGE");
      }
    );
  }

  async savesetting() {
    if (this.activeTab === 1) {
      switch (this.selectedScreen) {
        case "Depot-In":
          this.applicationUser.Screens.depotIn;
          break;
        case "Depot-Out":
          this.applicationUser.Screens.depotOut;
          break;
        case "PB-Screen":
          this.applicationUser.Screens.pbscreen;
          break;
        case "PB-Screen-Details":
          this.applicationUser.Screens.pbdetails;
          break;
        case "TO-Screen":
          this.applicationUser.Screens.toscreen;
          break;
        case "TO-Screen-Details":
          this.applicationUser.Screens.todetails;
          break;
        case "Planning-Board":
          this.applicationUser.Screens.planningBoard;
          break;
      }
      this.settingActions.updateSettings(
        this.applicationUser,
        "globalPrintSetting"
      );
    } else if (this.activeTab === 2) {
      this.applicationUser.defaultGridIcon = [...this.currentGridIcon];
      this.userActions.updateApplicationUser(
        this.applicationUser,
        "defaultGridIcon",
        true
      );
      this.applicationUser.toIcons = [...this.toIcons];
      this.userActions.updateApplicationUser(
        this.applicationUser,
        "toIcons",
        true
      );
      this.applicationUser.depotInGridIcons = [...this.depotInGridIcons];
      this.applicationUser.depotOutGridIcons = [...this.depotOutGridIcons];
      this.userActions.updateApplicationUser(this.applicationUser, "depotInGridIcons", true);
      this.userActions.updateApplicationUser(this.applicationUser, "depotOutGridIcons", true);
    } else if (this.activeTab === 3) {
      await this.setLandingPage();

      this.userActions.updateApplicationUserSucceded(this.applicationUser, true);
    } else if (this.activeTab === 4) {
      await this.setPixelsPerPB();
      await this.saveWeekPlanningSettings();
      await this.saveTmsActionCodeColorsSetting();

      this.userActions.updateApplicationUserSucceded(this.applicationUser, true);
    } else if (this.activeTab === 5) {
      await this.saveTimeLineToggleSettings();

      this.userActions.updateApplicationUserSucceded(this.applicationUser, true);
    } else if (this.activeTab === 6) {
      await this.saveCheckDateCompatibilitySetting();
      await this.saveClosedPbsCollapse();
      await this.savePlanningSettings();
      await this.saveChangePbSequence();
      await this.saveUsePopupScreenForEditingOrderlinesSetting();

      this.userActions.updateApplicationUserSucceded(this.applicationUser, true);
    } else if (this.activeTab === 7) {
      this.generalSetting.defaultPlanningGroupes = this.selectedPlanningGroups.map(x => x.id).join(",");
      await this.saveGeneralSettings();
      await this.setContainerSwap();
      await this.setEnableBargeAndCaptainLabels();
      await this.setSuggestPlanDateOption();
      await this.setServerSideSetting();

      this.userActions.updateApplicationUserSucceded(this.applicationUser, true);
    } else if (this.activeTab == 8) {
      await this.saveButtonsVisibilityChanges();
      this.userActions.updateApplicationUserSucceded(this.applicationUser, true);


    } else if (this.activeTab === 9) {
      await this.setEnableOptimisticUiSetting();
      await this.setEnableOptimisticUiBoardSetting();
      this.userActions.updateApplicationUserSucceded(this.applicationUser, true);
    }
  }

  saveChangePbSequence() {
    localStorage.setItem("changeSequence", JSON.stringify(this.changeSequence.value));
    return this.setGlobalSetting(this.sequenceSettings, "changeSequence", JSON.stringify(this.changeSequence.value),
      "TOASTR_MESSAGES.SUCCESS.CHANGE_PBs_SEQUENCE_SETTING_UPDATED", (data) => this.sequenceSettings = data);
  }

  saveGeneralSettings() {
    return this.setGlobalSetting(this.generalUserSetting, "generalSettings", JSON.stringify(this.generalSetting),
      "TOASTR_MESSAGES.SUCCESS.GLOBAL_SETTINGS", (data) => {
        this.generalUserSetting = data;
        this.applicationUser.generalSetting = this.generalSetting;
      });
  }

  saveClosedPbsCollapse() {
    localStorage.setItem("collapsedPbs", JSON.stringify(this.colllpasedPbs.value));
    return this.setGlobalSetting(this.collpasedSetting, "collapsedPbs", JSON.stringify(this.colllpasedPbs.value),
      "TOASTR_MESSAGES.SUCCESS.COLLAPSE_CLOSED_PBs_SETTING_UPDATED", (data) => this.collpasedSetting = data);
  }

  saveTimeLineToggleSettings() {
    localStorage.setItem("timeLine", JSON.stringify(this.timeline.value));
    return this.setGlobalSetting(this.timeLineSetting, "timeline", JSON.stringify(this.timeline.value),
      "TOASTR_MESSAGES.SUCCESS.TIME_LINE_TOGGLE_SETTING_UPDATED", (data) => this.timeLineSetting = data);
  }

  saveWeekPlanningSettings() {
    return this.setGlobalSetting(this.weekPlanningUserSetting, "weekPlanning", JSON.stringify(this.weekPlanningSetting),
      "TOASTR_MESSAGES.SUCCESS.WEEKPLANNING", (data) => {
        this.weekPlanningUserSetting = data;
        this.applicationUser.weekPlanningSetting = this.weekPlanningSetting;
      });
  }

  savePlanningSettings() {
    return this.setGlobalSetting(this.planningUserSetting, "planning", JSON.stringify(this.planningSetting),
      "TOASTR_MESSAGES.SUCCESS.PLANNING", (data) => {
        this.planningUserSetting = data;
        this.applicationUser.planningSetting = this.planningSetting;
      });
  }

  setPixelsPerPB() {
    return this.setGlobalSetting(this.pixelsPerPBSetting, "pixelsPerPlanningBlock", this.pixelsPerPlanningBlock.toString(),
      "TOASTR_MESSAGES.SUCCESS.PIXELS_PER_PB", (data) => {
        this.pixelsPerPBSetting = data;
        this.applicationUser.pixelsPerPlanningBlock = this.pixelsPerPlanningBlock;
      });
  }

  setContainerSwap() {
    return this.setGlobalSetting(this.enableContainerSwapSetting, "enableContainerSwap", this.enableContainerSwap.toString(),
      "TOASTR_MESSAGES.SUCCESS.ENABLE_CONTAINER_SWAP", (data) => {
        this.enableContainerSwapSetting = data;
        this.applicationUser.enableContainerSwap = this.enableContainerSwap;
      });
  }

  setEnableBargeAndCaptainLabels() {
    return this.setGlobalSetting(
      this.enableBargeAndCaptainLabelsSetting,
      "enableBargeAndCaptainLabels",
      this.enableBargeAndCaptainLabels.toString(),
      "TOASTR_MESSAGES.SUCCESS.ENABLE_BARGE_AND_CAPTAIN_LABELS", (data) => {
        this.enableBargeAndCaptainLabelsSetting = data;
        this.applicationUser.enableBargeAndCaptainLabels = this.enableBargeAndCaptainLabels;
      });
  }

  setSuggestPlanDateOption() {

    return this.setGlobalSetting(this.suggestPlanDateOptionSetting, "suggestPlanDateOption", this.suggestPlanDateOption,
      "TOASTR_MESSAGES.SUCCESS.SUGGEST_PLAN_DATE_OPTION", (data) => {
        this.generalUserSetting = data;
        this.applicationUser.suggestPlanDateOption = this.suggestPlanDateOption;
      });
  }


  setServerSideSetting() {
    return this.setGlobalSetting(this.serverSideFilteringSetting, "serverSideFiltering", this.serverSideFiltering.toString(),
      "TOASTR_MESSAGES.SUCCESS.SERVER_SIDE_FILTERING", (data) => {
        this.generalUserSetting = data;
        this.applicationUser.serverSideFiltering = this.serverSideFiltering;
      });
  }

  setEnableOptimisticUiSetting() {
    return this.setGlobalSetting(this.enableOptimisticUiSetting, "enableOptimisticUi", this.enableOptimisticUi.toString(),
      "TOASTR_MESSAGES.SUCCESS.OPTIMISTIC_UI_SETTING", (data) => {
        this.enableOptimisticUiSetting = data;
        this.applicationUser.enableOptimisticUi = this.enableOptimisticUi;
      });
  }

  setEnableOptimisticUiBoardSetting() {
    return this.setGlobalSetting(this.enableOptimisticUiBoardSetting, "enableOptimisticUiPlanningBoard", this.enableOptimisticUiPlanningBoard.toString(),
      "TOASTR_MESSAGES.SUCCESS.OPTIMISTIC_UI_SETTING", (data) => {
        this.enableOptimisticUiBoardSetting = data;
        this.applicationUser.enableOptimisticUiPlanningBoard = this.enableOptimisticUiPlanningBoard;
      });
  }

  setLandingPage() {
    return this.setGlobalSetting(this.landingPageSetting, "landingPage", this.selectedBackground.landingPage,
      "TOASTR_MESSAGES.SUCCESS.LANDINGPAGE", (data) => this.landingPageSetting = data);
  }

  async setGlobalSetting(setting: UserSettings, settingName: string, value: string, toastrMessage: string, setSetting) {
    if (setting) {
      setting.value = value;

      return this.userSettingsService.updateUserSettings(setting)
        .toPromise()
        .then(result => {
          setSetting(result.data);

          return this.translate.get(toastrMessage)
            .toPromise()
            .then(res => this.userFeedbackService.showSuccessMessageWithoutTranslating(res));
        });
    } else {
      // allowCreationOnMissing=true: auto-create the backend setting DEFINITION the first time a
      // brand-new setting name (e.g. enableOptimisticUi) is saved — otherwise the lookup returns
      // nothing, the user-setting create fails, and the success callback never runs (so it neither
      // persists nor applies). Existing definitions are simply found and returned unchanged.
      const setting = await this.userSettingsService.getSettingByName(settingName, true).toPromise();
      const createdUserSettings = await this.userSettingsService.createUserSettings(null, setting, value, null, null).toPromise();

      setSetting(createdUserSettings);

      return this.translate.get(toastrMessage)
        .toPromise()
        .then(res => this.userFeedbackService.showSuccessMessageWithoutTranslating(res));
    }
  }

  saveAndClose() {
    this.savesetting();
    this.closeModal();
  }

  getGridIcon(defaultGridIcon: GridIconSetting[], icons: GridIconSetting[]): GridIconSetting[] {
    let userGridSettings = [...defaultGridIcon];
    if (icons) {
      icons.forEach(el => {
        var userSetting = userGridSettings.find(us => us && el && us.id == el.id);
        if (userSetting != null) {
          userSetting.isVisible = el.isVisible;
        }
      });
    }
    return userGridSettings;
  }

  saveCheckDateCompatibilitySetting() {
    return this.setGlobalSetting(
      this.checkDateCompatibilitySetting,
      "checkDateCompatibility",
      this.checkDateCompatibility.toString(),
      "Run date confirmation logic setting updated",
      data => {
        this.checkDateCompatibilitySetting = data;
        this.applicationUser.checkDateCompatibility = this.checkDateCompatibility;
      }
    );
  }

  getCheckDateCompatibilitySetting(settings: UserSettings[]) {
    const setting = settings.find(el => el.setting.name === "checkDateCompatibility");

    if (setting) {
      this.checkDateCompatibilitySetting = setting;
    }
  }

  private setAndUpdateActionColors() {
    if (!this.tmsActionCodeColorSettingValue?.enabled) {
      return;
    }

    this.tmsActionService.fetchAll()
      .pipe(
        take(1)
      ).subscribe((tmsActions: TmsAction[]) => {
        if (this.tmsActionCodeColorSettingValue.actionColors?.length > 0) {
          // Remove actions that dont exist anymore
          this.tmsActionCodeColorSettingValue.actionColors = this.tmsActionCodeColorSettingValue.actionColors.filter(
            (actionColor: ActionCodeColor) => {
              return tmsActions.some((tmsAction: TmsAction) => tmsAction.code === actionColor.actionCode);
            }
          );

          // Add new actions that dont exist yet in the setting
          this.tmsActionCodeColorSettingValue.actionColors.push(
            ...tmsActions.filter(ta => this.tmsActionCodeColorSettingValue.actionColors.every(ac => ta.code !== ac.actionCode))
              .map((tmsAction: TmsAction) => {
                return {
                  actionCode: tmsAction.code,
                  color: "#FFFFFF"
                };
              })
          );
        } else {
          // Set default actions
          this.tmsActionCodeColorSettingValue.actionColors = tmsActions.map((tmsAction: TmsAction) => {
            if (tmsAction.code === "COMPLETED") {
              return {
                actionCode: tmsAction.code,
                color: "#3F4644"
              };
            }

            return {
              actionCode: tmsAction.code,
              color: "#FFFFFF"
            };
          });
        }
      });
  }

  showTmsActionCodeColorsSetting(checked: boolean) {
    if (this.tmsActionCodeColorSettingValue.enabled === checked) {
      return;
    }

    this.tmsActionCodeColorSettingValue.enabled = checked;

    this.setAndUpdateActionColors();
  }

  saveTmsActionCodeColorsSetting() {
    return this.setGlobalSetting(
      this.tmsActionCodeColorSetting,
      "tmsActionCodeColors",
      JSON.stringify(this.tmsActionCodeColorSettingValue),
      "TOASTR_MESSAGES.SUCCESS.ACTION_COLORS_UPDATED", (data) => {
        this.tmsActionCodeColorSetting = data;
        this.applicationUser.tmsActionCodeColorSetting = this.tmsActionCodeColorSettingValue;
      });
  }

  updateTmsActionCodeColor(actionColor: { color: string; id: string }) {
    this.tmsActionCodeColorSettingValue.actionColors
      .find(ac => ac.actionCode === actionColor.id).color = actionColor.color;
  }

  saveButtonsVisibilityChanges() {
    return this.setGlobalSetting(this.buttonsVisibilitySetting, 'buttonsVisibility', JSON.stringify(this.buttonsVisibility),
      "TOASTR_MESSAGES.SUCCESS.BUTTONS_VISIBILITY", (data) => {
        this.buttonsVisibilitySetting = data;
        this.applicationUser.buttonsVisibility = this.buttonsVisibility;
      });

  }

  private async saveUsePopupScreenForEditingOrderlinesSetting() {
    return this.setGlobalSetting(
      this.usePopupScreenForEditingOrderlinesSetting,
      "usePopupScreenForEditingOrderlines",
      JSON.stringify(this.usePopupScreenForEditingOrderlines),
      "TOASTR_MESSAGES.SUCCESS.USE_POPUP_SCREEN_FOR_EDITING_ORDERLINES_SETTING_UPDATED",
      data => {
        this.usePopupScreenForEditingOrderlinesSetting = data;
        this.applicationUser.usePopupScreenForEditingOrderlines = this.usePopupScreenForEditingOrderlines;
      }
    );
  }

  ngOnDestroy(): void {
    this._destroying$.next(null);
    this._destroying$.complete();
  }
}
